<template>
  <div class="welcomePage">
    <div class="content"
         :style="{ backgroundImage: 'url(https://betapp-images.s3.ap-northeast-1.amazonaws.com/vipbanner/w615wizcp6tzzjy6c5n5o0pkysws877wwelcome.webp)' }"
    style="background-size: 100% 100%"
    >
      <div class="playNow" @click="gotoHome"></div>
      <div class="download1" @click="download"></div>
      <div class="download2" @click="download"></div>
    </div>
  </div>
</template>

<script>
import config from '../../../static/config/config'

export default {
  name: 'Games',
  data () {
    return {}
  },
  components: {},
  created () {
  },
  mounted () {
  },
  methods: {
    gotoHome () {
      this.$router.push({path: '/Home'})
    },
    download () {
      window.location.href = config.baseURL + 'mobileapp/pge-app-' + config.apkVersion + '.apk'
    }
  }
}
</script>

<style lang="less" scoped>

.welcomePage {
  position: relative;
  top: 0;
  left: 50%;
  transform: translate(-50%);
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
}

.content {
  position: relative;
  top: 0;
  left: 50%;
  transform: translate(-50%);
  width: 360px;
  height: 944px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.playNow {
  position: absolute;
  width: 164px;
  height: 43px;
  top: 509.65px;
  left: 9.35px;
}

.download1 {
  position: absolute;
  top: 2px;
  left: 224.84px;
  width: 123px;
  height: 36.5px;
}

.download2 {
  position: absolute;
  top: 494px;
  left: 186.65px;
  width: 170.8px;
  height: 58.8px;
}

</style>



// WEBPACK FOOTER //
// src/pages/Welcome/index.vue